import React from "react";

import {Grid} from "@mui/material";
import {FormInput} from "../../../../../components/form/form_inputs/form_input";
import {FormContent} from "../../../../../components/form/form_inputs/form_buttons";
import { RecruitmentDocument, RecruitmentDocumentRestControllerApiFactory, Recruitment} from "arteco-api-client-ts";
import {useForm, UseFormProps,} from "../../../../../components/form/form_model";
import {useApiManager} from "../../../../../components/utils/api";
import {useParams} from "react-router-dom";
import FormFile from "../../../../../components/form/form_inputs/form_file";
import {useRecruitment} from "../index";
import {parsePathId} from "../../../../../components/form/form_utils";

export const RecruitmentDocumentEditPage = () => {
    const params = useParams();
    const recruitmentId = parsePathId(params, "recruitmentId");
    const manager = useApiManager();
    const ctrl = manager.factory(RecruitmentDocumentRestControllerApiFactory);

    const [recruitment, setRecruitment] = useRecruitment(recruitmentId);

    const form = useForm({
        fetcher: (id) => ctrl.getRecruitmentDocument(id),
        updater: (bean) => ctrl.saveRecruitmentDocument(bean),
        remover: (id) => ctrl.deleteOrDismissRecruitmentDocument(id),
        factory: () => {
            return {
                recruitment: {id: recruitmentId} as Recruitment,
            } as RecruitmentDocument;
        },
    } as UseFormProps<RecruitmentDocument>);

    return (
        <>
            <FormContent
                form={form}
                title={
                    "Documento para [" +
                    (recruitment ? recruitment.title : "") +
                    "]"
                }>

                <Grid item xs={12} sm>
                    <FormInput field={"title"} type={"text"} label={"Título"}/>
                </Grid>

                <FormInput field={"comments"} type={"text"} label={"Comentarios"} rows={5}/>

                <FormFile
                    field={"attachment"}
                    label={"Archivo"}
                    onDownload={() =>
                        manager.executeRaw(ctrl.viewRecruitmentDocumentRecruitmentDocument(form.getIdOrErr()))
                    }
                />

            </FormContent>
        </>
    );
};